import { useEffect, useRef } from "react";

import { hasRoleListShifted } from "./utils";

export const useOnRoleListShift = (roleListKeys: (string | number)[], onShift: () => void) => {
  const previousRoleListKeysRef = useRef(roleListKeys);

  useEffect(() => {
    if (hasRoleListShifted(previousRoleListKeysRef.current, roleListKeys)) {
      onShift();
    }
    previousRoleListKeysRef.current = roleListKeys;
  }, [roleListKeys, onShift]);
};
